import {
  isSanityImagePresent,
  PartialSanityImageType
} from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import { dequal } from "dequal/lite";

import React from "react";
import { isPresent } from "src/utils/checks";
import sanityLocation from "src/utils/sanityLocation";
import * as styles from "./NativeHeroImage.module.scss";
import { getGatsbyImageData } from "src/sanity-image-helpers";

type Props = {
  image: PartialSanityImageType;
  alt: string;
  className?: string;
  lazyload?: boolean;
};

const NativeHeroImage: React.FC<Props> = ({
  image,
  alt,
  className,
  lazyload = false
}) => {
  if (!isSanityImagePresent(image)) return null;

  const fixedImage = {
    ...image,
    _id: image.asset._id,
    asset: {
      _ref: image.asset._id
    }
  };

  const imageData = getGatsbyImageData(
    fixedImage,
    {
      layout: "fullWidth",
      sizes: "100vw",
      fit: "crop",
      quality: 70
    },
    sanityLocation
  );

  if (!imageData) return null;

  const objectPosition = image.hotspot
    ? [image.hotspot.x, image.hotspot.y]
        .filter(isPresent)
        .map((value) => (value * 100).toFixed(2) + "%")
        .join(" ")
    : undefined;

  return (
    <img
      {...imageData.images.fallback}
      loading={lazyload ? "lazy" : undefined}
      alt={alt}
      width={imageData.width}
      height={imageData.height}
      className={clsx(styles.image, className)}
      style={{
        objectPosition: objectPosition
      }}
    />
  );
};

export default React.memo(NativeHeroImage, dequal);
